import React from 'react';
import _ from 'lodash';
import { InputContainer } from '../../../../../common/components/form/input/containers/input.container';
import { AccordionContainer } from '../../../../../common/components/accordion/accordion.module';
export const BrandmappingMappedInfoComponent = ({ accounts, entityType, websites, webpages, dbas, orgRegistries, selectedFunctions, discount, tenantFunction, handleFormItemChange, deleteselectedFunction, openConfirmation, handleOpen, handleClose, webTemplateTypes, templateTypes, handleProductSearch, handleDeliverySearch, handleTierPriceSearch, handleCollectionPolicySearch, handleRewardPointSearch, handleDiscountSearch, handleVendorSearch, handleTopicSearch, handleModuleSearch, handleLearningPathSearch, handleCourseSearch, handleCollectionSearch, handleChannelSearch, handleCertificateSearch, handleAnnouncementSearch, handleCategorySearch, products, deliveries, collectionPolicies, tierPrices, rewards, discounts, organizationUnits, vendors, topics, modules, learningPaths, courses, collections, channels, certificates, announcements, categories, selectedFunction, selectedTemplate, handleInnerFormChange, back, handleFormSubmit }: any) => {


  return (
    <>
      <AccordionContainer
        child={
          <div>
            {_.map(selectedFunctions, (selectedFunction: any, itemIndex: any) => {

              const matchedFunction = tenantFunction.find(
                (item) => item.value === selectedFunction?.OwnerTypeId
              );
              return (
                <div key={itemIndex} className="border border-gray-800 p-4 mb-4 rounded-lg bg-gray-100">
                  <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
                    <InputContainer
                      label="Owner Type"
                      labelField="Description"
                      list={entityType}
                      onValueChange={(event: any, newValue: any) => {
                        const selectedOption = entityType.find(
                          (x) => x.Description === event.target.value
                        );
                        handleFormItemChange({
                          value: event.target.value,
                          field: 'OwnerType',
                          idx: itemIndex,
                        });
                        handleFormItemChange({
                          value: selectedOption?.Value,
                          field: 'OwnerTypeId',
                          idx: itemIndex,
                        });
                      }}
                      optionName="Choose Owner Type"
                      type="select"
                      value={selectedFunction?.OwnerType}
                      valueField="Description"
                    />

                    {selectedFunction?.OwnerType === 'Website' || selectedFunction?.OwnerTypeId === 10 ? (
                      <InputContainer
                        label="Website Name"
                        labelField="WebSiteName"
                        list={websites}
                        onValueChange={(event: any, newValue: any) => {
                          handleFormItemChange({
                            value: event.target.value,
                            field: 'OwnerId',
                            idx: itemIndex
                          });
                        }}
                        optionName='Choose Website Name'
                        type="select"
                        value={selectedFunction?.OwnerId}
                        valueField="Id"
                      />) : null}

                    {selectedFunction?.OwnerType === 'WebPage' || selectedFunction?.OwnerTypeId === 20 ? (

                      <InputContainer
                        label="Webpage Name"
                        labelField="Name"
                        list={webpages}
                        onValueChange={(event: any, newValue: any) => {
                          handleFormItemChange({
                            value: event.target.value,
                            field: 'OwnerId',
                            idx: itemIndex
                          });
                        }}
                        optionName='Choose Webpage'
                        type="select"
                        value={selectedFunction?.OwnerId}
                        valueField="Id"
                      />) : null}




                  </div>
                </div>
              )
            })}</div>}
        expandedPanel="Mapped Entities"
        headerTitle="Mapped Entities"
      />
    </>
  )
}
export default BrandmappingMappedInfoComponent;